<template>
  <div class="ds-pagination-bar">
    <div class="ds-pagination-bar__summary" v-if="summary || $slots.summary">
      <slot name="summary">{{ summary }}</slot>
    </div>
    <div class="ds-pagination-bar__pager">
      <slot name="default">
        <el-pagination
          :current-page="page"
          :page-size="size"
          :page-sizes="pageSizes"
          :total="total"
          :layout="layout"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </slot>
    </div>
  </div>
</template>

<script>
/**
 * DsPaginationBar —— 分页条
 *
 * 左侧放合计/统计提示，右侧放分页器。
 * 分页事件的语义与 el-pagination 完全一致（size-change / current-change），
 * 由父组件自行同步 page / size，**不改变既有分页写法**。
 *
 * Props:
 *  - total     {Number}  总条数
 *  - page      {Number}  当前页
 *  - size      {Number}  每页条数
 *  - pageSizes {Array}   每页条数可选值
 *  - layout    {String}  el-pagination layout
 *  - summary   {String}  左侧摘要文案
 *
 * Slots:
 *  - default   自定义分页器
 *  - summary   自定义摘要
 */
export default {
  name: 'DsPaginationBar',
  props: {
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50, 100]
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    summary: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    handleCurrentChange (val) {
      this.$emit('current-change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.ds-pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-spacing-md);
  flex-wrap: wrap;
  padding: var(--ds-spacing-md) var(--ds-spacing-lg);
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-top: none;
  border-radius: 0 0 var(--ds-radius-md) var(--ds-radius-md);

  &__summary {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
    min-width: 0;

    strong {
      color: var(--ds-gray-800);
      font-weight: 600;
    }
  }

  &__pager {
    flex-shrink: 0;
  }
}
</style>
